<template>
  <div
    id="app"
    :class="[
      layoutClass,
      theme,
      { background: showBackground },
      { 'hide-cursor': !isCursorEnabled },
    ]"
  >
    <Keno />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NoSleep from 'nosleep.js';
import Keno from '@/pages/Keno';

export default {
  name: 'App',
  components: {
    Keno,
  },
  computed: {
    ...mapState(['activeComponent']),
    ...mapGetters([
      'isCursorEnabled',
      'layoutClass',
      'theme',
      'isDesktop',
      'isMobile',
      'isTerminalLayout',
    ]),
    showBackground() {
      if (this.isTerminalLayout) {
        return this.activeComponent === 'BettingArea';
      }
      return !this.isMobile;
    },
  },
  mounted() {
    if (!this.isDesktop) {
      const noSleep = new NoSleep();
      let wakeLockEnabled = false;
      document.addEventListener(
        'click',
        function enableNoSleep() {
          document.removeEventListener('click', enableNoSleep, false);
          if (!wakeLockEnabled) {
            noSleep.enable();
            wakeLockEnabled = true;
          } else {
            noSleep.disable();
            wakeLockEnabled = false;
          }
        },
        false,
      );
    }
  },
};
</script>

<style lang="scss">
@use './styles/globals';
@use './styles/mixins';

html {
  background-color: hsl(var(--primary-hue), 10%, 11%);
}

body {
  background-color: var(--card);

  > .expanded-layout {
    background-repeat: no-repeat;
    background-size: cover;
  }

  > .compact-layout {
    background-repeat: no-repeat;
    background-size: cover;
  }

  #app {
    background-repeat: no-repeat;
    background-size: cover;
    &.background {
      &.dark {
        background-image: url('@/assets/images/background-dark.jpg');
      }

      &.light {
        background-image: url('@/assets/images/background-light.jpg');
      }
    }
  }

  @include mixins.mediaQuery('sm-min') {
    background-color: var(--background-1);
  }

  @include mixins.mediaQuery('compact-lg-min') {
    > .compact-layout {
      display: flex;
      justify-content: center;
    }
  }
}

.hide-cursor {
  * {
    cursor: none !important;
  }
}
</style>
